import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import update from 'immutability-helper';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import KTBSDropdown, {
  KTBSDropdowAutoCloseBehavior,
  KTBSDropdownAlignments,
  KTBSDropdownDirections,
} from '../OtherKeenComponents/KTBSDropdown';
import KTCheckbox, { KTCheckboxType } from '../OtherKeenComponents/KTFormControls/KTCheckbox';
import DragItem from './DragItem';
import AppConfigs from 'general/constants/AppConfigs';

DropdownTableConfigColumn.propTypes = {
  onChangeCheckboxValue: PropTypes.func,
  resetDefaultTableColumn: PropTypes.func,
  onSelectAll: PropTypes.func,
  onUnSelectAll: PropTypes.func,
  fullColumns: PropTypes.array,
  columnIds: PropTypes.array,
  fullColumnIds: PropTypes.array,
  onChangeFullColumnIds: PropTypes.func,
  direction: PropTypes.oneOf(Object.values(KTBSDropdownDirections)),
  hasActionColumn: PropTypes.bool,
  saveChanges: PropTypes.func,
};

function DropdownTableConfigColumn({
  onChangeCheckboxValue = null,
  resetDefaultTableColumn = null,
  onSelectAll = null,
  onUnSelectAll = null,
  fullColumns = [],
  columnIds = [],
  fullColumnIds = [],
  onChangeFullColumnIds = null,
  direction = KTBSDropdownDirections.down,
  hasActionColumn = true,
  saveChanges = null,
}) {
  // ---- params ----
  const [itemsCheck, setItemsCheck] = useState(columnIds);
  const [toggle, setToggle] = useState(true);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const isHideBike = AppConfigs.env.hideBike == 1;
  const getVisibleItems = () => {
    if (!fullColumnIds) return [];

    return fullColumnIds
      .filter(Boolean)
      .filter(id => !isHideBike || id !== 'VEHICLE_TYPE');
  };

  const [items, setItems] = useState(getVisibleItems);

  useEffect(() => {
    setItems(getVisibleItems());
  }, [fullColumnIds, isHideBike]);

  useEffect(() => {
    const isAllChecked = items.every((id) => itemsCheck.includes(id));
    setIsAllChecked(isAllChecked);
  }, [items, itemsCheck]);

  const handleCheckBoxChange = (key, checked) => {
    let tmpColumnIds = [...itemsCheck];
    if (!checked) {
      tmpColumnIds = tmpColumnIds.filter((row) => row !== key);
    } else {
      tmpColumnIds.push(key);
    }
    setItemsCheck(tmpColumnIds);
  };

  const { t } = useTranslation();
  const moveItem = useCallback((dragIndex, hoverIndex) => {
    setItems((prevItems) => {
      const tmp = update(prevItems, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevItems[dragIndex]],
        ],
      });
      return tmp;
    });
  }, []);

  const handleCloseDropdown = () => {
    $('#toggle-config-column').dropdown('toggle');
  };

  const handleSave = () => {
    onChangeFullColumnIds(items);
    saveChanges();
    handleCloseDropdown();
  };

  const getColumnName = (column) => {
    const children = column?.name?.props?.children;

    if (typeof children === 'string') return column?.name;
    if (Array.isArray(children)) return children[0];
    return children || column?.name;
  };

  return (
    <div>
      <DndProvider backend={HTML5Backend}>
        <KTBSDropdown
          id="toggle-config-column"
          contentEl={
            <div>
              <div
                className="p-4 d-flex flex-column min-w-350px overflow-auto"
                style={{
                  maxHeight: '30vh',
                }}
              >
                {/* <h6 className="font-weight-bolder">Thiết lập cột</h6> */}
                <div className="border d-flex">
                  <div
                    className="p-3 d-flex align-items-center"
                    style={{
                      borderRight: `1px solid ${AppColors.gray[300]}`,
                      backgroundColor: AppColors.gray[100],
                    }}
                  >
                    <i className="fa-solid fa-bars" style={{ fontSize: 12 }} />
                  </div>
                  <KTCheckbox
                    additionalClassName="checkbox-success p-3"
                    name="checkbox_all"
                    label={
                      <div
                        className="ml-2"
                        style={{
                          fontWeight: 400,
                          fontSize: 14,
                          color: AppColors.gray[800],
                        }}
                      >
                        {t('all')}
                      </div>
                    }
                    type={KTCheckboxType.default}
                    checked={isAllChecked}
                    onChange={() => {
                      if (!isAllChecked) {
                        onSelectAll?.();
                        setItemsCheck(fullColumnIds?.filter(Boolean) || []);
                      } else {
                        onUnSelectAll?.();
                        setItemsCheck([]);
                      }
                      setToggle((prev) => !prev);
                    }}
                  />
                </div>
                {items.map((item, index) => {
                  return !_.isUndefined(item) ? (
                    <DragItem
                      id={item ?? index + ''}
                      label={getColumnName(_.find(fullColumns, (row) => row?.id === item))}
                      checked={itemsCheck.includes(item)}
                      onCheckChanged={(id, checked) => {
                        handleCheckBoxChange(id, checked);
                        onChangeCheckboxValue(id, checked);
                      }}
                      key={item ?? index + ''}
                      moveItem={moveItem}
                      index={index}
                    />
                  ) : (
                    <div key={index}></div>
                  );
                })}
              </div>
              <div className="d-flex w-100 align-items-center justify-content-end gap-2 pt-4 pb-2 px-4 border-top">
                <Button
                  variant="secondary"
                  className="font-weight-bolder mr-2"
                  style={{
                    fontSize: 14,
                    color: AppColors.gray[800],
                  }}
                  onClick={() => {
                    setItemsCheck(fullColumnIds?.filter(Boolean) || []);
                    resetDefaultTableColumn();
                    setToggle(true);
                    handleCloseDropdown();
                  }}
                >
                  {t('Đặt lại mặc định')}
                </Button>

                <Button
                  variant="success"
                  className="font-weight-bolder"
                  style={{
                    fontSize: 14,
                  }}
                  onClick={() => {
                    handleSave();
                  }}
                >
                  {t('save')}
                </Button>
              </div>
            </div>
          }
          alignment={KTBSDropdownAlignments.end}
          autoCloseBehavior={KTBSDropdowAutoCloseBehavior.outside}
          toggleElement={
            <div
              onClick={() => { }}
              className="btn btn-light font-weight-bold d-flex align-items-center min-w-135px"
            >
              <img
                src={AppResource.icons.setColumnIcon}
                className="mb-1 mr-2"
                alt=""
                style={{ width: 15, height: 15 }}
              />
              <span
                className="font-weight-bolder"
                style={{ color: AppColors.gray[800], fontSize: 14 }}
              >
                Thiết lập cột
              </span>
            </div>
          }
          direction={direction}
        />
      </DndProvider>
    </div>
  );
}

export default DropdownTableConfigColumn;
